/**
 * @file DesktopKeepBanner.tsx
 * @description Claim banner for one artifact — who else keeps it on their
 * computer. Consumers: the form and record artifact surfaces, which pass the
 * path their route names.
 *
 * It exists as a shell around `DesktopKeepBannerHolders` for one reason: that
 * child holds a live `users` query listener for as long as it is mounted, so the
 * path check has to happen before it, not inside it. An artifact with no pinnable
 * path — a bare entity, or an id the route has not resolved yet — renders no
 * banner and opens no listener.
 *
 * Unlike `DesktopKeepControl`, this is not a control, so it is absent rather
 * than disabled when it has nothing to say.
 */

import { FC } from 'react';

import { resolveDesktopPinPath } from '@/use/desktopSync/resolveDesktopPinPath';
import DesktopKeepBannerHolders from './DesktopKeepBannerHolders';

export type DesktopKeepBannerProps = {
    artifactPath: string | undefined;
    artifactLabel: 'form' | 'record';
};

const DesktopKeepBanner: FC<DesktopKeepBannerProps> = ({ artifactPath, artifactLabel }) => {
    const pinPath = resolveDesktopPinPath(artifactPath);
    if (!pinPath) {
        return null;
    }

    return <DesktopKeepBannerHolders pinPath={pinPath} artifactLabel={artifactLabel} />;
};

export default DesktopKeepBanner;
